import { render, staticRenderFns } from "./EmailViewer.vue?vue&type=template&id=555c23d0&scoped=true&"
import script from "./EmailViewer.vue?vue&type=script&lang=js&"
export * from "./EmailViewer.vue?vue&type=script&lang=js&"
import style0 from "./EmailViewer.vue?vue&type=style&index=0&id=555c23d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c23d0",
  null
  
)

export default component.exports